import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import moment from 'utils/cops-moment';
import { Button } from 'ui';
import Table from 'common/table/legacy-table';
import * as styles from './create-order.css';

class OrdersTable extends Component {
  static propTypes = {
    orders: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { selectedOrder: null };
  }

  getColumns = () => {
    const {
      intl,
    } = this.props;

    const { formatMessage: translate } = intl;
    return [
      {
        label: translate({ id: 'orderWizard.ordersTable.PLANNED_DATE' }),
        dataIndex: 'plannedDate',
        format: 'date',
      },
      {
        label: translate({ id: 'orderWizard.ordersTable.DATE_GAP' }),
        renderValueFn: (value, row) => row?.plannedDate ?
          moment(row.plannedDate).fromNow() :
          '',
      },
      {
        label: translate({ id: 'orderWizard.ordersTable.DESCRIPTION' }),
        dataIndex: 'name',
      },
      {
        label: translate({ id: 'orderWizard.ordersTable.VISIT' }),
        dataIndex: 'visitType',
      },
      {
        label: translate({ id: 'orderWizard.ordersTable.STATUS' }),
        dataIndex: 'status',
      },
      {
        label: translate({ id: 'orderWizard.ordersTable.BUSINESS_INDICATOR' }),
        dataIndex: 'businessIndicator',
      },
      {
        label: translate({ id: 'orderWizard.ordersTable.TYPE' }),
        dataIndex: 'type',
      },
    ];
  };

  handleRowSelect = selectedOrders =>
    this.setState({
      selectedOrder: selectedOrders?.find((o, i) => i === selectedOrders.length - 1),
    });


  render() {
    const { orders, onSubmit, isSubmitting } = this.props;

    const getCheckboxProps = record => ({
      disabled: !record.isActionable,
    });

    return (
      <>
        <Table
          columns={this.getColumns()}
          data={orders}
          selectedRowKeys={[this.state.selectedOrder]}
          onRowSelect={this.handleRowSelect}
          shouldCalculateAutoWidth={true}
          getCheckboxProps={getCheckboxProps}
        />
        <div className={styles.useScheduledBtnGrp}>
          <Button
            disabled={!this.state.selectedOrder}
            onClick={() => onSubmit(this.state.selectedOrder)}
            loading={isSubmitting}
            type='secondary'
          >
            <FormattedMessage id='orderWizard.USE_SCHEDULED_ITEM_BTN' />
          </Button>
        </div>
      </>
    );
  }
}

export default injectIntl(OrdersTable);
